import { cva } from 'class-variance-authority';

export const filtersAccordionTriggerVariants = cva(
	'hidden p-5 data-[state=open]:bg-white-dark-1 sm:flex md:py-4 border',
	{
		variants: {
			variant: {
				primary: 'border-white-dark-3 data-[state=open]:bg-white-dark-1',
				dark: 'border-primary-light-3 data-[state=open]:bg-primary-light-4'
			}
		},
		defaultVariants: {
			variant: 'primary'
		}
	}
);

export const filtersAccordionContentVariants = cva(
	'flex w-full flex-col px-0 pb-0 sm:pb-4',
	{
		variants: {
			variant: {
				primary: 'text-primary',
				dark: 'text-white-dark-4'
			}
		},
		defaultVariants: {
			variant: 'primary'
		}
	}
);

export const filtersAccordionTitleVariants = cva(
	'font-matter-sq text-xl font-normal tracking-[-0.025rem]',
	{
		variants: {
			variant: {
				primary: 'text-primary',
				dark: 'text-white-dark-4'
			}
		},
		defaultVariants: {
			variant: 'primary'
		}
	}
);
